module.exports = __webpack_public_path__ + "static/media/TC_Concierge.03d735e9.png";